import {
  ConfigApi,
  PaymentTerminalApi,
  ProviderApi,
  StationApi,
  VivaApi,
} from "./api";
import { ActionPasscodesApi } from "./apis/action-passcodes-api";
import { AuthApi } from "./apis/auth-api";
import { EmployeeShiftsApi } from "./apis/employee-shifts-api";
import { EmployeesApi } from "./apis/employees-api";
import { HistoryApi } from "./apis/history-api";
import { InvoiceCompaniesApi } from "./apis/invoice-companies-api";
import { InvoicingApi } from "./apis/invoicing-api";
import { MetabaseApi } from "./apis/metabase-api";
import { MetabaseV3Api } from "./apis/metabase-v3-api";
import { OperatingModeApi } from "./apis/operating-mode-api";
import { PaymentMethodsApi } from "./apis/payment-methods-api";
import { PermissionCatalogApi } from "./apis/permission-catalog-api";
import { ReportsApi } from "./apis/reports-api";
import { RolesPermissionsApi } from "./apis/roles-permissions-api";
import { UserApi } from "./apis/user-api";
import { VenueApi } from "./apis/venue-api";
import { apiConfig, axiosInstance } from "./client";

export const defaultQueryOptions = {
  refetchOnWindowFocus: false,
  staleTime: 60000,
  retry: 1,
};

export const apiInstances = {
  authApi: new AuthApi(apiConfig, undefined, axiosInstance),
  userApi: new UserApi(apiConfig, undefined, axiosInstance),
  metabaseApi: new MetabaseApi(apiConfig, undefined, axiosInstance),
  metabaseV3Api: new MetabaseV3Api(apiConfig, undefined, axiosInstance),
  reportsApi: new ReportsApi(apiConfig, undefined, axiosInstance),
  venueApi: new VenueApi(apiConfig, undefined, axiosInstance),
  employeeApi: new EmployeesApi(apiConfig, undefined, axiosInstance),
  shiftApi: new EmployeeShiftsApi(apiConfig, undefined, axiosInstance),
  roleApi: new RolesPermissionsApi(apiConfig, undefined, axiosInstance),
  permissionCatalogApi: new PermissionCatalogApi(
    apiConfig,
    undefined,
    axiosInstance,
  ),
  actionPasscodesApi: new ActionPasscodesApi(
    apiConfig,
    undefined,
    axiosInstance,
  ),
  operatingModeApi: new OperatingModeApi(apiConfig, undefined, axiosInstance),
  historyApi: new HistoryApi(apiConfig, undefined, axiosInstance),
  invoiceCompaniesApi: new InvoiceCompaniesApi(
    apiConfig,
    undefined,
    axiosInstance
  ),
  invoicingApi: new InvoicingApi(apiConfig, undefined, axiosInstance),
  paymentMethodsApi: new PaymentMethodsApi(apiConfig, undefined, axiosInstance),
  configApi: new ConfigApi(apiConfig, undefined, axiosInstance),
  vivaApi: new VivaApi(apiConfig, undefined, axiosInstance),
  stationApi: new StationApi(apiConfig, undefined, axiosInstance),
  paymentTerminalApi: new PaymentTerminalApi(
    apiConfig,
    undefined,
    axiosInstance
  ),
  providerApi: new ProviderApi(apiConfig, undefined, axiosInstance),
};

export { apiConfig };
